import {
  FaBoxOpen,
  FaGift,
  FaPercent,
  FaPizzaSlice,
  FaRulerCombined,
  FaShoppingCart,
  FaTags,
  FaTruck,
} from 'react-icons/fa';
import { promotionsTypes } from '../../enums/promotionsTypes';

export const tipoPromocaoOptions = [
  { label: 'Desconto percentual', value: promotionsTypes.DESCONTO_PERCENTUAL },
  { label: 'Desconto fixo', value: promotionsTypes.DESCONTO_VALOR_FIXO },
  { label: 'Leve X pague Y', value: promotionsTypes.LEVE_X_PAGUE_Y },
  { label: 'Compre e ganhe', value: promotionsTypes.COMPRE_E_GANHE },
  { label: 'Combo preço fixo', value: promotionsTypes.COMBO_PRECO_FIXO },
  { label: 'Frete grátis', value: promotionsTypes.FRETE_GRATIS },
  { label: 'Bordas', value: promotionsTypes.BORDAS },
  { label: 'Desconto por tamanho (pizza)', value: promotionsTypes.DESCONTO_TAMANHO },
];

export const tipoPromocaoBadgeStyle = {
  [promotionsTypes.DESCONTO_PERCENTUAL]: { bg: '#f3e8ff', color: '#7c3aed' },
  [promotionsTypes.DESCONTO_VALOR_FIXO]: { bg: '#fce7f3', color: '#db2777' },
  [promotionsTypes.LEVE_X_PAGUE_Y]: { bg: '#ffedd5', color: '#c2410c' },
  [promotionsTypes.COMPRE_E_GANHE]: { bg: '#fee2e2', color: '#dc2626' },
  [promotionsTypes.COMBO_PRECO_FIXO]: { bg: '#dbeafe', color: '#2563eb' },
  [promotionsTypes.FRETE_GRATIS]: { bg: '#ccfbf1', color: '#0d9488' },
  [promotionsTypes.BORDAS]: { bg: '#fef3c7', color: '#b45309' },
  [promotionsTypes.DESCONTO_TAMANHO]: { bg: '#dcfce7', color: '#16a34a' },
};

export const tipoPromocaoBadgeFallback = { bg: '#f1f5f9', color: '#475569' };

export const getTipoPromocaoLabel = (tipo) =>
  tipoPromocaoOptions.find((opcao) => opcao.value === tipo)?.label || tipo;

export const tipoPromocaoIcon = {
  [promotionsTypes.DESCONTO_PERCENTUAL]: FaPercent,
  [promotionsTypes.DESCONTO_VALOR_FIXO]: FaTags,
  [promotionsTypes.LEVE_X_PAGUE_Y]: FaShoppingCart,
  [promotionsTypes.COMPRE_E_GANHE]: FaGift,
  [promotionsTypes.COMBO_PRECO_FIXO]: FaBoxOpen,
  [promotionsTypes.FRETE_GRATIS]: FaTruck,
  [promotionsTypes.BORDAS]: FaPizzaSlice,
  [promotionsTypes.DESCONTO_TAMANHO]: FaRulerCombined,
};

export const tipoPromocaoIconFallback = FaTags;
